var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 393,
    height: 40,
    viewBox: "0 0 393 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_7173",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 393,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 393,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_7173)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 393,
    height: 40,
    fill: "#111015"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 36.5554V65H153.627V36.5562H150.054V43.667H146.482V36.5562H142.909V40.1116H139.336V36.5562H142.909V33.0009H135.763V36.5562H132.191V40.1116H128.618V36.5562H132.191V33.0009H128.618V29.4455H125.045V25.8902H121.473V29.4455H117.9V36.5562H114.327V29.4455H110.754V25.8902H103.609V29.4455H107.182V33.0009H110.754V36.5562H107.182V33.0009H103.609V29.4455H100.036V33.0009H96.4635V29.4455H92.8907V33.0009H89.318V29.4455H92.8907V25.8902H85.7453V22.3348H82.1726V29.4455H85.7453V33.0009H82.1726V29.4455H75.0271V33.0009H78.5999V36.5562H82.1726V40.1116H78.5999V36.5562H75.0271V33.0009H71.4544V25.8902H67.8817V22.3348H64.309V25.8902H60.7363V33.0009H57.1635V36.5562H53.5908V40.1116H50.0181V36.5562H53.5908V33.0009H57.1635V29.4455H53.5908V25.8902H50.0181V22.3348H46.4454V25.8902H42.8727V29.4446L50.0181 29.4455V33.0009H46.4454V40.1116H42.8727V29.4446H39.2999V36.5554H35.7272V29.4446H39.2999V25.8893H35.7272V22.3339H32.1545V18.7786H28.5818L28.5827 25.8893L32.1545 25.8893V29.4446H28.5818V33H25.009V36.5554H21.4363V33H25.009V29.4446H17.8636V36.5554H14.2909V29.4446H10.7182V25.8893H7.14544V33H10.7182V40.1107H7.14544V33H3.57272V36.5554H0ZM35.729 43.667H39.3017V47.2223H35.729V43.667ZM67.8853 47.2223V43.667H71.458V47.2223H67.8853ZM92.8952 43.667H89.3225V40.1116H92.8952V43.667ZM107.187 47.2223H103.614V43.667H107.187V47.2223ZM17.8645 43.667V40.1116H21.4372V43.667H17.8645ZM28.5836 40.1116V36.5562H32.1563V40.1116H28.5836ZM64.3126 40.1116H60.7398V36.5562H64.3126V40.1116ZM64.3126 29.4446H67.8853V33H64.3126V29.4446ZM100.042 40.1107V36.5554H103.614V40.1107H100.042ZM114.333 43.6661V40.1107H117.906V43.6661H114.333ZM121.48 33H125.052V36.5554H121.48V33ZM135.771 47.2223H132.198V43.667H135.771V47.2223Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.14544 22.3339L7.14544 25.8893L3.57272 25.8893V29.4446H0V25.8893H3.57272L3.57272 22.3339L0 22.3339V18.7786H3.57272L3.57272 22.3339H7.14544Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7182 22.3339L7.14544 22.3339L7.14543 18.7786H10.7182L10.719 15.2223H14.2918V18.7777L10.7182 18.7786V22.3339Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7182 22.3339L14.2918 22.3339V25.8893L10.7182 25.8893L10.7182 22.3339Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0099 25.8893L25.009 29.4446H28.5818L28.5827 25.8893H25.0099Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4372 22.3339V25.8893H25.0099L25.01 22.3339H21.4372Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4372 22.3339L21.4372 18.7786H17.8645V22.3339L21.4372 22.3339Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.489 36.5554H150.061V33H146.489V36.5554Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.489 29.4446L146.489 33L142.916 33V29.4446L139.343 29.4446V25.8893H142.916L142.916 22.3339L139.343 22.333V18.7777H142.916L142.916 22.3339H146.489V25.8893H150.061L150.062 18.7777L157.209 18.7786V22.3339H160.781L160.781 18.7786H164.354V15.2223H167.927V18.7777L164.354 18.7786V22.3339H167.927V25.8893L164.354 25.8902V29.4455H167.927V36.5562H171.5V29.4455H178.645L178.646 25.8893H175.073V22.3339L171.5 22.3339V18.7786H175.073L175.073 22.3339H178.646L178.646 25.8893L182.219 25.8902L182.218 18.7795H185.79V22.3348H189.363V25.8902H192.936V29.4455H196.509V25.8911H200.081V22.3357H203.654V25.8911H207.227V29.4464H210.799V33.0018H214.372V25.8911H217.945V22.3357H221.518V25.8911H225.09V33.0018H228.663V65H153.636V36.5562H157.209V33.0009H160.781V25.8902L157.209 25.8893V29.4446L153.635 29.4446V33L150.061 33L150.062 29.4446H146.489ZM153.635 25.8893H150.061L150.062 29.4446H153.635V25.8893ZM153.635 25.8893H157.209V22.3339L153.635 22.333V25.8893ZM160.781 33.0009H164.354V40.1116H160.781V33.0009ZM207.227 36.5571V33.0018H210.799V36.5571H207.227ZM207.227 36.5571V40.1125H203.654V36.5571H207.227ZM196.509 29.4455L203.654 29.4464V33.0018H200.081V40.1125H196.509V29.4455ZM192.936 29.4455V36.5562H189.363V29.4455H192.936ZM182.218 29.4455L182.219 25.8902H185.79V29.4455H182.218ZM178.645 33.0009V29.4455H182.218V33.0009H178.645ZM178.645 33.0009V36.5562H175.072V33.0009H178.645ZM160.781 25.8902H164.354L164.354 22.3339H160.781V25.8902ZM146.489 29.4446V25.8893H142.916L142.916 29.4446H146.489ZM189.365 43.667H192.938V47.2223H189.365V43.667ZM171.5 43.667V40.1116H175.073V43.667H171.5ZM182.22 40.1116V36.5562H185.792V40.1116H182.22ZM217.949 40.1116H214.376V36.5562H217.949V40.1116ZM217.949 29.4446H221.521V33H217.949V29.4446ZM221.521 43.667H225.094V47.2223H221.521V43.667Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.458 18.7777H75.0307V15.2223H71.458V18.7777Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8853 18.7777V22.333H71.458L71.458 18.7777L67.8853 18.7777Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3126 15.2223V18.7777L67.8853 18.7777L67.8853 15.2223H64.3126Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3126 11.667L64.3126 15.2223L60.7398 15.2223L60.7389 18.7777L57.1662 18.7777V22.333H60.7399V25.8893H53.5935V22.333H50.0208V18.7777H42.8744V25.8893H39.3017V22.333H35.729V18.7777L32.1563 18.7777V11.667L28.5836 11.667L28.5827 15.2223H25.0099V11.667L28.5836 11.667V8.11162H32.1563L32.1563 11.667H35.729V8.11161L39.3017 8.11161V4.55625H42.8744V8.11161H39.3017L39.3017 15.2223H35.729L35.729 18.7777H42.8744L42.8744 15.2223H50.0208L50.0208 18.7777H57.1662L57.1662 15.2223L60.7398 15.2223V11.667H64.3126Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3126 8.11161V11.667L67.8853 11.667V8.11162L64.3126 8.11161Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3126 8.11161V4.55625H60.7398V8.11161H64.3126Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.624 29.4446H132.197V25.8893H128.624V29.4446Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.624 22.3339V25.8893H125.051V22.3339H121.479V25.8893H117.906V29.4446H114.333V25.8893H110.76V22.3339H103.614V25.8893H100.042V29.4446H96.4688V25.8893H92.8952V22.333H89.3225V18.7777H96.4688L96.4688 25.8893H100.042V22.3339H103.614V18.7777L100.042 18.7777V15.2223H103.614V18.7777H110.76L110.76 22.3339H114.332L114.333 18.7777L117.906 18.7777V15.2223H121.479L121.479 18.7777H125.051V22.3339H128.624ZM117.906 22.3339H114.332L114.333 25.8893H117.906L117.906 22.3339ZM117.906 22.3339V18.7777L121.479 18.7777L121.479 22.3339H117.906Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.198 22.3339H128.624V18.7777H132.197L132.198 15.2223H135.771V18.7777L132.197 18.7777L132.198 22.3339Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.198 22.3339H135.771V25.8893H132.197L132.198 22.3339Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0307 25.8893H78.6034V22.3339H75.0307V25.8893Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6034 22.3339L82.177 22.333V18.7777H78.6043L78.6034 22.3339Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.061 15.2223H146.489V11.667H150.061L150.062 8.11162H153.635V11.667L150.061 11.667V15.2223Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.343 8.11161H142.916V15.2223H139.343V8.11161Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.624 15.2223H125.051V11.667H128.624V15.2223Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.332 15.2223H110.76V11.667H114.332V15.2223Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8952 15.2223H89.3225V11.667L85.7498 11.667L85.7498 15.2223H78.6043V11.667L75.0307 11.667V8.11162H78.6034L78.6043 11.667L85.7498 11.667V8.11162L82.1771 8.11161V4.55625H85.7498V8.11162H89.3225V4.55625H92.8952V8.11161L89.3225 8.11162V11.667H92.8952V15.2223Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.198 11.667H135.771V8.11162H132.198V11.667Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.906 4.55537V11.667H121.479V4.55537H117.906Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.614 11.667H107.187V8.11162H103.614V11.667Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.042 8.11162H103.614V4.55625H100.042V8.11162Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.042 8.11162H96.4688V11.667H100.042V8.11162Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.614 4.55625L107.187 4.55536V1H103.614V4.55625Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5935 11.667V4.55537H57.1662V11.667H53.5935Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0208 11.667H46.4481V8.11162H50.0208V11.667Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.332 8.11161H110.76V4.55625H114.332V8.11161Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.635 4.55536H150.062V1H153.635V4.55536Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.624 4.55536H125.051V1H128.624V4.55536Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.458 4.55536H67.8853V1H71.458V4.55536Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0208 4.55536H46.4481V1H50.0208V4.55536Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.916 4.55536H139.343V1H142.916V4.55536Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8645 8.11161H21.4372V15.2223H17.8645V8.11161Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.14544 15.2223H3.57272V11.667H7.14544V15.2223Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.719 11.667H14.2918V8.11162H10.719V11.667Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5836 4.55536H32.1563V1H28.5836V4.55536Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.719 4.55536H14.2918V1H10.719V4.55536Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.57272 8.11161H7.14544V4.55625H3.57272V8.11161Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.094 18.7777H228.667V15.2223H225.094V18.7777Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.521 18.7777V22.333H225.094L225.094 18.7777L221.521 18.7777Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.948 15.2223V18.7777L221.521 18.7777L221.52 15.2223H217.948Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.948 11.667L217.948 15.2223H214.375V18.7777L210.802 18.7777V22.333H214.375V25.8893H207.229V22.333H203.657V18.7777L196.51 18.7777L196.51 25.8893H192.938V22.333H189.365V18.7777L185.792 18.7777V11.667L182.219 11.667V15.2223H178.646V11.667H182.219L182.219 8.11162H185.791L185.792 11.667H189.365V8.11161L192.938 8.11161V4.55625H196.51V8.11161H192.938V15.2223H189.365L189.365 18.7777L196.51 18.7777V15.2223H203.657V18.7777H210.802L210.802 15.2223H214.375L214.375 11.667H217.948Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.948 8.11161V11.667L221.52 11.667V8.11162L217.948 8.11161Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.948 8.11161V4.55625H214.375V8.11161H217.948Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.229 4.55537V11.667H210.802V4.55537H207.229Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.083 11.667H203.656V8.11162H200.083V11.667Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.094 4.55536H221.521V1H225.094V4.55536Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.656 4.55536H200.083V1H203.656V4.55536Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.5 15.2223H175.073V8.11161H171.5V15.2223Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.209 15.2223H160.781V11.667H157.209V15.2223Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.354 11.667H167.927V8.11162H164.354V11.667Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.219 4.55536H185.791V1H182.219V4.55536Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.354 4.55536H167.927V1H164.354V4.55536Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.209 8.11161H160.781V4.55625H157.209V8.11161Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.667 36.5554V65H382.294V36.5562H378.721V43.667H375.148V36.5562H371.576V40.1116H368.003V36.5562H371.576V33.0009H364.43V36.5562H360.857V40.1116H357.285V36.5562H360.857V33.0009H357.285V29.4455H353.712V25.8902H350.139V29.4455H346.566V36.5562H342.994V29.4455H339.421V25.8902H332.276V29.4455H335.848V33.0009H339.421V36.5562H335.848V33.0009H332.276V29.4455H328.703V33.0009H325.13V29.4455H321.557V33.0009H317.985V29.4455H321.557V25.8902H314.412V22.3348H310.839V29.4455H314.412V33.0009H310.839V29.4455H303.694V33.0009H307.267V36.5562H310.839V40.1116H307.267V36.5562H303.694V33.0009H300.121V25.8902H296.548V22.3348H292.976V25.8902H289.403V33.0009H285.83V36.5562H282.257V40.1116H278.685V36.5562H282.257V33.0009H285.83V29.4455H282.257V25.8902H278.685V22.3348H275.112V25.8902H271.539V29.4446L278.685 29.4455V33.0009H275.112V40.1116H271.539V29.4446H267.967V36.5554H264.394V29.4446H267.967V25.8893H264.394V22.3339H260.821V18.7786H257.248L257.249 25.8893L260.821 25.8893V29.4446H257.248V33H253.676V36.5554H250.103V33H253.676V29.4446H246.53V36.5554H242.958V29.4446H239.385V25.8893H235.812V33H239.385V40.1107H235.812V33H232.239V36.5554H228.667ZM264.396 43.667H267.968V47.2223H264.396V43.667ZM296.552 47.2223V43.667H300.125V47.2223H296.552ZM321.562 43.667H317.989V40.1116H321.562V43.667ZM335.854 47.2223H332.281V43.667H335.854V47.2223ZM246.531 43.667V40.1116H250.104V43.667H246.531ZM257.25 40.1116V36.5562H260.823V40.1116H257.25ZM292.979 40.1116H289.407V36.5562H292.979V40.1116ZM292.979 29.4446H296.552V33H292.979V29.4446ZM328.708 40.1107V36.5554H332.281V40.1107H328.708ZM343 43.6661V40.1107H346.573V43.6661H343ZM350.146 33H353.719V36.5554H350.146V33ZM364.437 47.2223H360.865V43.667H364.437V47.2223Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.812 22.3339V25.8893L232.239 25.8893V29.4446H228.667V25.8893H232.239V22.3339L228.667 22.3339V18.7777L232.239 18.7786V22.3339H235.812Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.385 22.3339L235.812 22.3339L235.812 18.7786H239.385L239.386 15.2223H242.958V18.7777L239.385 18.7786V22.3339Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.385 22.3339L242.958 22.3339V25.8893L239.385 25.8893L239.385 22.3339Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.677 25.8893L253.676 29.4446H257.248L257.249 25.8893H253.677Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.104 22.3339V25.8893H253.677V22.3339H250.104Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.104 22.3339L250.104 18.7786H246.531V22.3339L250.104 22.3339Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.155 36.5554H378.728V33H375.155V36.5554Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375.155 29.4446L375.155 33L371.583 33V29.4446L368.01 29.4446V25.8893H371.583L371.583 22.3339L368.01 22.333V18.7777H371.583L371.583 22.3339H375.155V25.8893H378.728L378.729 18.7777L385.875 18.7786V22.3339H389.448V18.7786H393.021V15.2223H396.594V18.7777L393.021 18.7786V22.3339H396.594V25.8893L393.021 25.8902V29.4455H396.594V36.5562H400.166V29.4455H407.312L407.313 25.8893H403.74V22.3339L400.167 22.3339V18.7786H403.74L403.74 22.3339H407.313L407.313 25.8893L410.885 25.8902L410.884 18.7795H414.457V22.3348H418.03V25.8902H421.603V29.4455H425.175V25.8911H428.748V22.3357H432.321V25.8911H435.893V29.4464H439.466V33.0018H443.039V25.8911H446.612V22.3357H450.184V25.8911H453.757V33.0018H457.33V65H382.303V36.5562H385.875V33.0009H389.448V25.8902L385.875 25.8893V29.4446L382.302 29.4446V33L378.728 33L378.729 29.4446H375.155ZM382.302 25.8893H378.728L378.729 29.4446H382.302V25.8893ZM382.302 25.8893H385.875V22.3339L382.302 22.333V25.8893ZM389.448 33.0009H393.021V40.1116H389.448V33.0009ZM435.893 36.5571V33.0018H439.466V36.5571H435.893ZM435.893 36.5571V40.1125H432.321V36.5571H435.893ZM425.175 29.4455L432.321 29.4464V33.0018H428.748V40.1125H425.175V29.4455ZM421.603 29.4455V36.5562H418.03V29.4455H421.603ZM410.884 29.4455L410.885 25.8902H414.457V29.4455H410.884ZM407.312 33.0009V29.4455H410.884V33.0009H407.312ZM407.312 33.0009V36.5562H403.739V33.0009H407.312ZM389.448 25.8902H393.021L393.021 22.3339H389.448V25.8902ZM375.155 29.4446V25.8893H371.583L371.583 29.4446H375.155ZM418.032 43.667H421.604V47.2223H418.032V43.667ZM400.167 43.667V40.1116H403.74V43.667H400.167ZM410.886 40.1116V36.5562H414.459V40.1116H410.886ZM446.615 40.1116H443.042V36.5562H446.615V40.1116ZM446.615 29.4446H450.188V33H446.615V29.4446ZM450.188 43.667H453.761V47.2223H450.188V43.667Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.125 18.7777H303.697V15.2223H300.125V18.7777Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.552 18.7777V22.333H300.125V18.7777L296.552 18.7777Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.979 15.2223V18.7777L296.552 18.7777V15.2223H292.979Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.979 11.667V15.2223L289.407 15.2223L289.406 18.7777L285.833 18.7777V22.333H289.407V25.8893H282.26V22.333H278.687V18.7777H271.541V25.8893H267.968V22.333H264.396V18.7777L260.823 18.7777V11.667L257.25 11.667L257.249 15.2223H253.677V11.667L257.25 11.667V8.11162H260.823L260.823 11.667H264.396V8.11161L267.968 8.11161V4.55625H271.541V8.11161H267.968V15.2223H264.396V18.7777H271.541V15.2223H278.687L278.687 18.7777H285.833L285.833 15.2223L289.407 15.2223V11.667H292.979Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.979 8.11161V11.667L296.552 11.667V8.11162L292.979 8.11161Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.979 8.11161V4.55625H289.407V8.11161H292.979Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.291 29.4446H360.864V25.8893H357.291V29.4446Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M357.291 22.3339V25.8893H353.718V22.3339H350.146V25.8893H346.573V29.4446H343V25.8893H339.426V22.3339H332.281V25.8893H328.708V29.4446H325.135V25.8893H321.562V22.333H317.989V18.7777H325.136L325.135 25.8893H328.708V22.3339H332.281V18.7777L328.708 18.7777V15.2223H332.281V18.7777H339.426V22.3339H342.999L343 18.7777L346.573 18.7777V15.2223H350.146L350.145 18.7777H353.718V22.3339H357.291ZM346.573 22.3339H342.999L343 25.8893H346.573L346.573 22.3339ZM346.573 22.3339V18.7777L350.145 18.7777L350.146 22.3339H346.573Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.865 22.3339H357.291V18.7777H360.864L360.865 15.2223H364.437V18.7777L360.864 18.7777L360.865 22.3339Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.865 22.3339H364.437V25.8893H360.864L360.865 22.3339Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.697 25.8893H307.27V22.3339H303.697V25.8893Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.27 22.3339L310.844 22.333V18.7777H307.271L307.27 22.3339Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.728 15.2223H375.155V11.667H378.728L378.729 8.11162H382.302V11.667L378.728 11.667V15.2223Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.01 8.11161H371.583V15.2223H368.01V8.11161Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.291 15.2223H353.718V11.667H357.291V15.2223Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.999 15.2223H339.426V11.667H342.999V15.2223Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.562 15.2223H317.989V11.667L314.416 11.667L314.416 15.2223H307.271V11.667L303.697 11.667V8.11162H307.27L307.271 11.667L314.416 11.667V8.11162L310.844 8.11161V4.55625H314.416V8.11162H317.989V4.55625H321.562V8.11161L317.989 8.11162V11.667H321.562V15.2223Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.865 11.667H364.437V8.11162H360.865V11.667Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.573 4.55537V11.667H350.146V4.55537H346.573Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.281 11.667H335.854V8.11162H332.281V11.667Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.708 8.11162H332.281V4.55625H328.708V8.11162Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.708 8.11162H325.135V11.667H328.708V8.11162Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.281 4.55625L335.854 4.55536V1H332.281V4.55625Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.26 11.667V4.55537H285.833V11.667H282.26Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.687 11.667H275.115V8.11162H278.687V11.667Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.999 8.11161H339.426V4.55625H342.999V8.11161Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.302 4.55536H378.729V1H382.302V4.55536Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.291 4.55536H353.718V1H357.291V4.55536Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.125 4.55536H296.552V1H300.125V4.55536Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.687 4.55536H275.115V1H278.687V4.55536Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.583 4.55536H368.01V1H371.583V4.55536Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.531 8.11161H250.104V15.2223H246.531V8.11161Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.812 15.2223H232.239V11.667H235.812V15.2223Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.386 11.667H242.958V8.11162H239.386V11.667Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.25 4.55536H260.823V1H257.25V4.55536Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.386 4.55536H242.958V1H239.386V4.55536Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.239 8.11161H235.812V4.55625H232.239V8.11161Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.761 18.7777H457.333V15.2223H453.761V18.7777Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.188 18.7777V22.333H453.761L453.761 18.7777L450.188 18.7777Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.614 15.2223V18.7777L450.188 18.7777L450.187 15.2223H446.614Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.614 11.667V15.2223H443.042V18.7777L439.469 18.7777V22.333H443.042V25.8893H435.896V22.333H432.323V18.7777L425.177 18.7777L425.177 25.8893H421.604V22.333H418.032V18.7777L414.459 18.7777V11.667L410.885 11.667V15.2223H407.313V11.667H410.885L410.885 8.11162H414.458L414.459 11.667H418.032V8.11161L421.604 8.11161V4.55625H425.177V8.11161H421.604V15.2223H418.032L418.032 18.7777L425.177 18.7777V15.2223H432.323V18.7777H439.469L439.469 15.2223H443.042L443.042 11.667H446.614Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.614 8.11161V11.667L450.187 11.667V8.11162L446.614 8.11161Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.614 8.11161V4.55625H443.042V8.11161H446.614Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.896 4.55537V11.667H439.469V4.55537H435.896Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.75 11.667H432.323V8.11162H428.75V11.667Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.761 4.55536H450.188V1H453.761V4.55536Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.323 4.55536H428.75V1H432.323V4.55536Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.167 15.2223H403.74V8.11161H400.167V15.2223Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.875 15.2223H389.448V11.667H385.875V15.2223Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.021 11.667H396.594V8.11162H393.021V11.667Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.885 4.55536H414.458V1H410.885V4.55536Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.021 4.55536H396.594V1H393.021V4.55536Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.875 8.11161H389.448V4.55625H385.875V8.11161Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M457.333 65V36.5554H460.906V33H464.479V25.8893L460.906 25.8893V29.4446H457.333V25.8893H460.906V22.3339L457.333 22.3339V18.7777L460.906 18.7786V22.3339H464.479V18.7786H468.052L468.052 15.2223H471.625V18.7777L468.052 18.7786V22.3339L471.625 22.3339V25.8893L468.052 25.8893V29.4446H471.624V36.5554H475.197V29.4446H482.342L482.343 25.8893H478.771V22.3339L475.198 22.3339V18.7786H478.771L478.771 22.3339H482.343V25.8893H485.916L485.915 18.7786H489.488V22.3339H493.061V25.8893H496.633V29.4446H500.206V25.8902H503.779V22.3348H507.351V25.8902H510.924V29.4455H514.497V33.0009H518.07V25.8902H521.642V22.3348H525.215V25.8902H528.788V33.0009H532.36V29.4455H539.506V22.3348H543.079V25.8902H550.224V29.4455H553.797V33.0009H557.37V29.4455H560.942V25.8902H568.088V29.4455H571.66V36.5562H575.233V29.4455H578.806V25.8902H582.379V29.4455H585.951V33.0009H589.524V36.5562H593.097V33.0009H600.242V36.5562H603.815V43.667H607.388V36.5562H610.96V65H457.333ZM600.242 36.5562H596.669V40.1116H600.242V36.5562ZM589.524 36.5562H585.951V40.1116H589.524V36.5562ZM564.515 33.0009V29.4455H560.942V33.0009H564.515ZM564.515 33.0009V36.5562H568.088V33.0009H564.515ZM550.224 29.4455H546.651V33.0009H550.224V29.4455ZM539.506 29.4455V33.0009H543.079V29.4455H539.506ZM535.933 36.5562V33.0009H532.36V36.5562H535.933ZM535.933 36.5562V40.1116H539.506V36.5562H535.933ZM510.924 36.5562H514.497V33.0009H510.924V36.5562ZM510.924 36.5562H507.351V40.1116H510.924V36.5562ZM500.206 29.4446V40.1116H503.779V33.0009H507.351V29.4455L500.206 29.4446ZM496.633 29.4446H493.061V36.5554H496.633V29.4446ZM485.915 29.4446H489.488V25.8893L485.916 25.8893L485.915 29.4446ZM482.342 33H485.915V29.4446H482.342V33ZM482.342 33H478.77V36.5554H482.342V33ZM468.052 25.8893V22.3339L464.479 22.3339V25.8893H468.052ZM464.479 33V40.1107H468.052V33H464.479ZM496.635 43.667H493.062V47.2223H496.635V43.667ZM525.219 43.667V47.2223H528.791V43.667H525.219ZM546.656 43.667H550.229V40.1116H546.656V43.667ZM560.948 47.2223H564.52V43.667H560.948V47.2223ZM475.198 40.1116V43.667H478.771V40.1116H475.198ZM485.917 36.5562V40.1116H489.49V36.5562H485.917ZM518.073 40.1116H521.646V36.5562H518.073V40.1116ZM525.219 29.4446H521.646V33H525.219V29.4446ZM557.375 36.5554V40.1107H560.948V36.5554H557.375ZM571.667 40.1107V43.6661H575.239V40.1107H571.667ZM582.386 33H578.813V36.5554H582.386V33ZM589.531 47.2223H593.104V43.667H589.531V47.2223Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M607.395 36.5554H603.822V33L600.249 33V29.4446L596.677 29.4446V25.8893H600.249V22.3339L596.677 22.333V18.7777H600.249V22.3339H603.822V25.8893H607.395L607.396 18.7777L614.542 18.7786V22.3339H618.115V18.7786H621.687V15.2223H625.26V18.7777L621.687 18.7786V22.3339H625.26V25.8893L621.688 25.8902V29.4455H625.26V36.5562H628.833V29.4455H635.978L635.979 25.8893H632.407V22.3339L628.834 22.3339V18.7786H632.406L632.407 22.3339H635.979V25.8893L639.552 25.8902L639.551 18.7795H643.124V22.3348H646.697V25.8902H650.269V29.4455H653.842V25.8911H657.415V22.3357H660.987V25.8911H664.56V29.4464H668.133V33.0018H671.706V25.8911H675.278V22.3357H678.851V25.8911H682.424V33.0018H685.996V65H610.969V36.5562H614.542V33.0009H618.115V25.8902L614.542 25.8893V29.4446L610.968 29.4446V33L607.395 33V36.5554ZM607.396 29.4446L607.395 33H603.822L603.822 29.4446H600.249V25.8893H603.822V29.4446H607.396ZM607.396 29.4446L607.395 25.8893H610.968V22.333L614.542 22.3339V25.8893H610.968V29.4446H607.396ZM618.115 33.0009V40.1116H621.688V33.0009H618.115ZM664.56 36.5571H668.133V33.0018H664.56V36.5571ZM664.56 36.5571H660.987V40.1125H664.56V36.5571ZM653.842 29.4455V40.1125H657.415V33.0018H660.987V29.4464L653.842 29.4455ZM650.269 29.4455H646.697V36.5562H650.269V29.4455ZM639.551 29.4455H643.124V25.8902H639.552L639.551 29.4455ZM635.978 33.0009H639.551V29.4455H635.978V33.0009ZM635.978 33.0009H632.406V36.5562H635.978V33.0009ZM618.115 25.8902V22.3339H621.687L621.688 25.8902H618.115ZM650.271 43.667H646.698V47.2223H650.271V43.667ZM628.834 40.1116V43.667H632.407V40.1116H628.834ZM639.553 36.5562V40.1116H643.126V36.5562H639.553ZM671.709 40.1116H675.282V36.5562H671.709V40.1116ZM678.855 29.4446H675.282V33H678.855V29.4446ZM682.427 43.667H678.855V47.2223H682.427V43.667Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.364 18.7777H528.791V22.333H525.219V18.7777L521.646 18.7777V15.2223L518.073 15.2223L518.072 18.7777L514.5 18.7777V22.333H518.073V25.8893H510.927V22.333H507.354V18.7777H500.208V25.8893H496.635V22.333H493.062V18.7777L489.49 18.7777V11.667L485.917 11.667L485.916 15.2223H482.343V11.667L485.917 11.667V8.11162H489.49V11.667H493.062V8.11161L496.635 8.11161V4.55625H500.208V8.11161H496.635L496.635 15.2223H493.062V18.7777H500.208L500.208 15.2223H507.354L507.354 18.7777H514.5V15.2223L518.073 15.2223V11.667H521.646V8.11161H518.073V4.55625H521.646V8.11161L525.219 8.11162V11.667L521.646 11.667L521.646 15.2223H525.219V18.7777L528.791 18.7777V15.2223H532.364V18.7777Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M589.53 29.4446H585.958V25.8893H582.385V22.3339H578.812V25.8893H575.239V29.4446H571.667V25.8893H568.093V22.3339H560.948V25.8893H557.375V29.4446H553.802V25.8893H550.229V22.333H546.656V18.7777H553.802V25.8893H557.375V22.3339H560.948V18.7777L557.375 18.7777V15.2223H560.948V18.7777H568.093V22.3339H571.666L571.667 18.7777L575.239 18.7777V15.2223H578.812L578.812 18.7777H582.385V22.3339H585.958V18.7777H589.53L589.531 15.2223H593.104V18.7777L589.53 18.7777L589.531 22.3339H593.104V25.8893H589.53V29.4446ZM589.53 25.8893L589.531 22.3339H585.958V25.8893H589.53ZM575.239 22.3339H578.812L578.812 18.7777L575.239 18.7777V22.3339ZM575.239 22.3339H571.666L571.667 25.8893H575.239V22.3339Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.937 25.8893H532.364V22.3339H535.937L535.938 18.7777H539.51V22.333L535.937 22.3339V25.8893Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.822 15.2223H607.395V11.667H603.822V15.2223Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.395 11.667L610.968 11.667V8.11162H607.396L607.395 11.667Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.249 8.11161H596.677V15.2223H600.249V8.11161Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.385 15.2223H585.958V11.667H582.385V15.2223Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.093 15.2223H571.666V11.667H568.093V15.2223Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.656 15.2223H550.229V11.667H546.656V15.2223Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.656 8.11162V11.667L543.083 11.667V15.2223H535.938V11.667L532.364 11.667V8.11162H535.937L535.938 11.667L543.083 11.667V8.11162L539.51 8.11161V4.55625H543.083V8.11162H546.656Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.656 8.11162L550.229 8.11161V4.55625H546.656V8.11162Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.104 11.667H589.531V8.11162H593.104V11.667Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.239 11.667V4.55537H578.812V11.667H575.239Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.52 11.667H560.948V8.11162H557.375V11.667H553.802V8.11162H557.375V4.55625H560.948V1H564.52V4.55536L560.948 4.55625V8.11162H564.52V11.667Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.927 4.55537V11.667H514.5V4.55537H510.927Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.781 11.667H507.354V8.11162H503.781V11.667Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.093 8.11161H571.666V4.55625H568.093V8.11161Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.396 4.55536H610.968V1H607.396V4.55536Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.385 4.55536H585.958V1H582.385V4.55536Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.219 4.55536H528.791V1H525.219V4.55536Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.781 4.55536H507.354V1H503.781V4.55536Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.677 4.55536H600.249V1H596.677V4.55536Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.771 8.11161H475.198V15.2223H478.771V8.11161Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.906 15.2223H464.479V11.667H460.906V15.2223Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.625 11.667H468.052V8.11162H471.625V11.667Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.49 4.55536H485.917V1H489.49V4.55536Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.625 4.55536H468.052V1H471.625V4.55536Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.479 8.11161H460.906V4.55625H464.479V8.11161Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686 18.7777H682.427V22.333H678.855V18.7777L675.281 18.7777V15.2223H671.708V18.7777L668.135 18.7777V22.333H671.708V25.8893H664.563V22.333H660.99V18.7777L653.844 18.7777L653.844 25.8893H650.271V22.333H646.698V18.7777L643.126 18.7777V11.667L639.552 11.667V15.2223H635.979V11.667H639.552L639.552 8.11162H643.125L643.126 11.667H646.698V8.11161L650.271 8.11161V4.55625H653.844V8.11161H650.271V15.2223H646.698L646.698 18.7777L653.844 18.7777V15.2223H660.99V18.7777H668.135V15.2223H671.708L671.708 11.667H675.281V8.11161H671.708V4.55625H675.281V8.11161L678.854 8.11162V11.667L675.281 11.667L675.281 15.2223H678.854L678.855 18.7777L682.427 18.7777V15.2223H686V18.7777Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.563 11.667V4.55537H668.136V11.667H664.563Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.989 11.667H657.416V8.11162H660.989V11.667Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.855 4.55536H682.427V1H678.855V4.55536Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.416 4.55536H660.989V1H657.416V4.55536Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.406 15.2223H628.834V8.11161H632.406V15.2223Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.115 15.2223H614.542V11.667H618.115V15.2223Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.26 11.667H621.687V8.11162H625.26V11.667Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.125 4.55536H639.552V1H643.125V4.55536Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.26 4.55536H621.687V1H625.26V4.55536Z",
    fill: "#24232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.115 8.11161H614.542V4.55625H618.115V8.11161Z",
    fill: "#24232A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecor);
export default __webpack_public_path__ + "static/media/decor.9c719aa1f509b1ac81c044e97aeb0745.svg";
export { ForwardRef as ReactComponent };